var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { mapGetters, mapActions } from 'vuex';
import { MENU_ITEMS, CART, CART_OPTION, STORAGE_KEYS, LOCATION } from '@/stores/defs';
import { isEmpty } from 'lodash';
import displayPriceMixin from '@Mixin/displayPriceMixin';
import Promise from 'ts-promise';
import cartService from '@/services/cart.service.ts';
import alertMixin from '@Mixin/alertMixin';
var localforage = require('localforage');
var cartKeyName = STORAGE_KEYS.cartKeyName;
// const cartMockSpecials = require('@/mocks/MockCartWithSpecials');
// const cartMockLargeOrder = require('@/mocks/MockCartLargeOrder');
var mixinName = {
    mixins: [
        displayPriceMixin,
        alertMixin,
    ],
    computed: __assign({}, mapGetters({
        itemCount: CART.ITEM_COUNT,
        lineItemCount: CART.LINE_ITEM_COUNT,
        getCartItems: CART.ITEMS,
        cartTotals: CART.GET_TOTALS,
        cartOptionChoices: CART_OPTION.GET_CHOICES,
        getLocationModel: LOCATION.GET_LOCATION,
        getItem: MENU_ITEMS.GET_ITEM,
    }), { noItems: function () {
            return !this.hasItems();
        },
        cart_hasItems: function () {
            return this.hasItems();
        },
        displayCartSubTotal: function () {
            var totals = this.cartTotals;
            var subTotal = totals.subTotal;
            return this.displayPrice(subTotal);
        } }),
    methods: __assign({}, mapActions({
        setCart: CART.SET_ITEMS,
        clearCart: CART.CLEAR_CART,
    }), { hasItems: function () {
            return this.itemCount > 0;
        },
        displayItemCount: function () {
            var itemCount = this.itemCount;
            var label = 'items';
            if (itemCount === 1) {
                label = 'item';
            }
            return itemCount + "x " + label + " in cart";
        },
        displayShortItemCount: function () {
            var itemCount = this.itemCount;
            return itemCount + "x";
        },
        navigateToCheckout: function () {
            this.$router.push({ path: '/checkout' });
        },
        _requiredOptionSelected: function (optionId) {
            var choices = this.cartOptionChoices(optionId);
            if (choices && choices.length > 0) {
                return true;
            }
            return false;
        },
        getPersistedCartItems: function () {
            var checkPromise = localforage.getItem(cartKeyName);
            return checkPromise;
        },
        fetchCart: function () {
            var cart = null;
            if (!isEmpty(this.getCartItems)) {
                cart = Promise.resolve(this.getCartItems);
            }
            if (isEmpty(cart)) {
                cart = this.getPersistedCartItems();
            }
            return cart;
        },
        validationMessage: function (fetchedCart, currentCart) {
            if (isEmpty(currentCart) && isEmpty(fetchedCart)) {
                return;
            }
            var itemTotal = currentCart.length;
            var compareTotal = fetchedCart.length;
            if (itemTotal !== compareTotal) {
                var message = (itemTotal === 0) ?
                    'The items in your cart could not be transferred due to changes in the menu.' :
                    'Some of the items in your cart could not be transferred due to changes in the menu.';
                this.alertWithMessage('Issue with cart', message);
            }
        },
        _initializeCart: function () {
            var vue = this;
            var fetchCart = this.fetchCart();
            fetchCart.then(function (cart) {
                if (isEmpty(cart)) {
                    return;
                }
                var locationBase = vue.getLocationModel.id;
                cartService.initializeCartItems(cart, locationBase, vue.validationMessage);
            });
        } }),
};
export default mixinName;



//////////////////
// WEBPACK FOOTER
// ./src/components/mixins/cartMixin.ts
// module id = 3a9x
// module chunks = 18